import { createTranslations } from '@npco/utils-translations'

export const expenseCardLowAvailableBalanceTranslations = createTranslations({
  messageAdmin:
    'This card has less than 10% of its allocated budget remaining.',
  message: 'You have less than 10% of your allocated budget remaining.',
  editButton: 'Edit Spend Limit',
})
